import React, { createContext, useContext, useState, useCallback } from 'react';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toasts, setToasts] = useState([]);

  const addToast = useCallback((message, type = 'info', duration = 4000, onClick = null) => {
    const id = Date.now() + Math.random();
    setToasts((prev) => [...prev, { id, message, type, onClick }]);
    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, duration);
  }, []);

  return (
    <ToastContext.Provider value={{ addToast }}>
      {children}
      <div className="fixed top-4 right-4 left-4 sm:left-auto sm:right-6 sm:top-6 z-[60] space-y-3 pointer-events-none">
        {toasts.map((toast) => (
          <div
            key={toast.id}
            onClick={() => {
              if (toast.onClick) {
                toast.onClick();
              }
              setToasts((prev) => prev.filter((t) => t.id !== toast.id));
            }}
            className={`pointer-events-auto px-4 py-3 rounded-xl shadow-2xl text-white font-bold animate-slide-in-right border-2 border-white/20 cursor-pointer active:scale-95 transition-all
              ${toast.type === 'error' ? 'bg-red-600' : toast.type === 'success' ? 'bg-green-600' : 'bg-fud-dark'}`}
          >
            <div className="flex items-center gap-3">
              <span className="flex-grow">{toast.message}</span>
            </div>
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
};
